import React, { Component, createRef } from 'react';
import { Formik, Form } from 'formik';
import { map, keys, find } from 'lodash';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import NoPhoto from '../../../shared/images/backgrounds/no_photo.png';
import { baseURL } from '../../../shared/helpers/axiosConfiguration';
import generalInformationSchema from '../../schemas/generalInformationSchema';
import styles from './generalInformation.module.scss';

export default class GeneralInformation extends Component {
    constructor(props) {
        super(props);

        this.form = createRef();
        this.uploadImageButton = createRef();
    }

    componentDidMount() {
        if (this.props.match.params.id && !this.form.current.state.isSubmitting) {
            this.form.current.submitForm();
        }
    }

    async handleChange(field, value) {
        await this.form.current.setFieldValue(field, value, false);

        const validForm = await this.form.current.validateForm();

        if (keys(validForm).length === 0) {
            await this.form.current.submitForm();
        } else if (this.props.ready) {
            this.props.generalInformationReady(false);
        }
    }

    handleSubmit() {
        this.props.generalInformationReady(true, this.form.current.state.values);
    }

    matchLanguage() {
        const defaultLanguage = find(this.props.language, { key: window.navigator.language });

        return defaultLanguage ? defaultLanguage.key : 'en';
    }

    render() {
        const status = [{
            key: 1,
            value: 'ENABLED'
        }, {
            key: 0,
            value: 'disabled'
        }, {
            key: 2,
            value: 'suspended'
        }];

        return (
            <div className={styles.container}>
                <Formik
                    ref={this.form}
                    initialValues={{
                        Names: this.props.edition.user ? this.props.edition.user.Names : '',
                        LastNames: this.props.edition.user ? this.props.edition.user.LastNames : '',
                        Emails: this.props.edition.user ? this.props.edition.user.Emails : '',
                        MobileNumber: this.props.edition.user ? this.props.edition.user.MobileNumber : '',
                        Language: this.props.edition.user ? this.props.edition.user.Language : this.matchLanguage(),
                        Status: this.props.edition.user ? this.props.edition.user.Status : '1',
                        Picture: null,
                        PicturePreview:
                            this.props.edition.user &&
                                this.props.edition.user.PictureURL !== '/user/upload_pic/User-alt-128.png'
                                ? `${baseURL}${this.props.edition.user.PictureURL}`
                                : NoPhoto
                    }}
                    enableReinitialize={true}
                    validationSchema={generalInformationSchema}
                    onSubmit={() => this.handleSubmit()}
                    render={props => (
                        <Form>
                            <div className={styles.photoBackground}>
                                <div className={styles.photoContainer} onClick={() => this.uploadImageButton.current.click()}>
                                    <img
                                        alt='userPhoto'
                                        className={styles.photo}
                                        src={props.values.PicturePreview}
                                        height={135}
                                        width={135}
                                    />
                                    <span>{this.props.t('common:change')}</span>
                                    <input
                                        type="file"
                                        name="Picture"
                                        accept=".png, .jpg, .jpeg"
                                        size="4000000"
                                        ref={this.uploadImageButton} onChange={event => {
                                            URL.revokeObjectURL(props.values.PicturePreview);

                                            this.handleChange('PicturePreview', URL.createObjectURL(event.target.files[0]));
                                            this.handleChange('Picture', event.target.files[0]);
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={styles.formContainer}>
                                <div className={styles.row}>
                                    <TextField
                                        disabled={this.props.isCreating}
                                        label={this.props.t('common:NAME')}
                                        type="text"
                                        name="Names"
                                        className={styles.field}
                                        value={props.values.Names}
                                        onChange={event => this.handleChange('Names', event.target.value)}
                                        onBlur={props.handleBlur}
                                        error={props.touched.Names && !!props.errors.Names}
                                        helperText={props.touched.Names && !!props.errors.Names
                                            ? <span>{this.props.t(`validations:${props.errors.Names}`)}</span>
                                            : ''
                                        }
                                    />
                                    <TextField
                                        disabled={this.props.isCreating}
                                        label={this.props.t('users:last_name')}
                                        type="text"
                                        name="LastNames"
                                        className={styles.field}
                                        value={props.values.LastNames}
                                        onChange={event => this.handleChange('LastNames', event.target.value)}
                                        onBlur={props.handleBlur}
                                        error={props.touched.LastNames && !!props.errors.LastNames}
                                        helperText={props.touched.LastNames && !!props.errors.LastNames
                                            ? <span>{this.props.t(`validations:${props.errors.LastNames}`)}</span>
                                            : ''
                                        }
                                    />
                                    <TextField
                                        disabled={this.props.isCreating}
                                        label={this.props.t('common:EMAIL')}
                                        type="email"
                                        name="Emails"
                                        className={styles.field}
                                        value={props.values.Emails}
                                        onChange={event => this.handleChange('Emails', event.target.value)}
                                        onBlur={props.handleBlur}
                                        error={props.touched.Emails && !!props.errors.Emails}
                                        helperText={props.touched.Emails && !!props.errors.Emails
                                            ? <span>{this.props.t(`validations:${props.errors.Emails}`)}</span>
                                            : ''
                                        }
                                    />
                                </div>
                                <div className={styles.row}>
                                    <TextField
                                        disabled={this.props.isCreating}
                                        type="text"
                                        label={this.props.t('users:mobile_phone')}
                                        name="MobileNumber"
                                        value={props.values.MobileNumber}
                                        onChange={event => this.handleChange('MobileNumber', event.target.value)}
                                        onBlur={props.handleBlur}
                                        className={styles.field}
                                        error={props.touched.MobileNumber && !!props.errors.MobileNumber}
                                        helperText={props.touched.MobileNumber && !!props.errors.MobileNumber
                                            ? <span>{this.props.t('validations:NO_PHONE_AREA_CODE')}</span>
                                            : <span>{this.props.t('validations:NO_PHONE_AREA_CODE')}</span>
                                        }
                                    />
                                    <FormControl className={styles.field}>
                                        <InputLabel htmlFor="Language">{this.props.t('common:LANGUAGE')}</InputLabel>
                                        <Select
                                            disabled={this.props.isCreating}
                                            value={props.values.Language}
                                            onChange={event => this.handleChange('Language', event.target.value)}
                                            onBlur={props.handleBlur}
                                            input={<Input name="Language" />}
                                        >
                                            {map(this.props.language, language =>
                                                <MenuItem key={language.key} value={language.key}>{language.value}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <FormControl className={styles.field}>
                                        <InputLabel htmlFor="Status">{this.props.t('common:status')}</InputLabel>
                                        <Select
                                            disabled={this.props.isCreating}
                                            value={props.values.Status}
                                            onChange={event => this.handleChange('Status', event.target.value)}
                                            onBlur={props.handleBlur}
                                            input={<Input name="Status" />}
                                        >
                                            {map(status, status =>
                                                <MenuItem key={status.key} value={status.key}>
                                                    {this.props.t(`common:${status.value}`)
                                                    }</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                        </Form>
                    )}
                />
            </div>
        );
    }
};
